// extracted by mini-css-extract-plugin
export default {"item":"styleAuth_item__H7Sly","link":"styleAuth_link__roe5E","active":"styleAuth_active__jdEQT"};